<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <hint :value="inputHint" />
    <label :for="inputId" class="control-label">{{ inputLabel }}</label>
    <v-select
      v-model="inputValue"
      :filter="customFilter"
      :disabled="disabled"
      :id="inputId"
      :options="colors"
      :reduce="x => x.name"
      type="text"
      label="name"
      autocomplete="off"
      transition=""
    >
      <span slot="no-options">Цвет не найден. <br>Если это ошибка, обратитесь в поддержку.</span>
      <template #open-indicator="{ attributes }">
        <svg width="14" height="8" xmlns="http://www.w3.org/2000/svg" v-bind="attributes">
          <path stroke="null" id="svg_1" d="m10.838366,0.093268l-4.59,4.58l-4.59,-4.58l-1.41,1.41l6,6l6,-6l-1.41,-1.41z"/>
        </svg>
      </template>
    </v-select>
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import VSelect from 'vue-select'
import visitorsSectionMixin from '../../../../mixins/application-form/visitorsSectionMixin'
import visitorInputMixin from '../../../../mixins/application-form/visitorInputMixin'
import transportInputMixin from '../../../../mixins/application-form/transportInputMixin'
import Hint from '@/common/components/inputs/components/Hint.vue'

export default {
  name: 'TransportColorInput',

  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    visitorsSectionMixin,
    visitorInputMixin,
    transportInputMixin
  ],

  components: {
    Hint,
    VSelect
  },

  props: {
    inputLabel: {
      default: 'Цвет ТС'
    },

    inputName: {
      default: 'color'
    },

    inputHint: {
      default: undefined
    },

    typeaheadItemKey: {
      default: null
    },

    colors: {
      type: Array,
      default: () => [],
      required: true
    }
  },

  computed: {
    inputId() {
      return `form-visitor-transport-color-${this.visitorIndex}-${this.transportIndex}`
    }
  },

  methods: {
    customFilter(options, search) {
      return options.filter(option => {
        return option.name.toLowerCase().startsWith(search.toLowerCase())
      })
    }
  }
}
</script>
